import { CSSProperties, ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  extraClassName?: string;
  style?: CSSProperties;
  noMargin?: boolean;
}

const Card = ({ children, extraClassName, style, noMargin: _noMargin }: CardProps) => {
  return (
    <div
      className={`bg-sd-card text-sd-card-foreground flex flex-col p-5 rounded-xl border border-sd-border shadow-sm ${extraClassName ?? ''}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default Card;
